import { Injectable } from '@angular/core';
import { BehaviorSubject, concat, Observable, of, throwError, Subject, Subscription } from 'rxjs';
import { map, switchMap, take, tap, takeUntil } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { MatDrawer } from '@angular/material/sidenav';

import { RealtimedbService } from "../../../../firebase/realtimedb.service";
import { FirestoreService } from "../../../../firebase/firestore.service";

@Injectable({
    providedIn: 'root'
})
export class OverviewService
{
    // Private
    private drawer: MatDrawer;

    public currentSystemId: string = "";
    public currentRoute: string = "home";
    public currentTrailer: string = ""
    public moduleId: string = null
    public moduleName: string = null
    public session_id: string = null
    public modulesId: any = []

    public sys_online: boolean = true

    // Service subscriptions
    ngUnsubscribe: Subject<void> = new Subject();
    systemsSubs: Subscription

    devicesLayout: boolean = true

    /**
     * Constructor
     */
    constructor(private rtdbService: RealtimedbService, public firestore: FirestoreService)
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    sysOnlineSubscribe(){

        if(this.moduleId){
        
           this.systemsSubs = this.rtdbService.getOnChange(`systems_registered/${this.moduleId}/status`).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
                //console.log(data[1].payload.val() )
                if (data[1].payload.val() === true){
                    this.sys_online = true
                    //console.log(this.sys_online)
                }
                else if( data[1].payload.val() === false){
                    this.sys_online = false
                    //console.log(this.sys_online)
                }
            });
        }
    }

    unsubscribe(){
        // Unsubscribe from all subscriptions
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();

        if(this.systemsSubs) this.systemsSubs.unsubscribe()
    }

    removeSystemUser(){
        /*if(this.moduleId){
            this.firestore.updateDocs("systems",this.moduleId, {"users":{[this.session_id]:this.firestore.fieldValueDelete()}})
        }*/
        if (this.modulesId.length>0){

            for(var i in this.modulesId){
                //console.log(this.modulesId[i])
                this.firestore.updateDocs("systems",this.modulesId[i], {"users":{[this.session_id]:this.firestore.fieldValueDelete()}})
            }
        }
        this.modulesId = []
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    setDrawer(drawer: MatDrawer) {
        this.drawer = drawer;
    }
    
    toggle(): void {
        this.drawer.toggle();
    }

    systemStream(enable: boolean, pageToFind: string){
        //console.log(pageToFind)
        //console.log(enable)
        //console.log(this.moduleId)


        const id = (element) => element === this.moduleId;
        const index = this.modulesId.findIndex(id);
        if(index == -1){
            this.modulesId.push(this.moduleId)
        }

        const user_ = JSON.parse(sessionStorage.getItem('user'));

        this.session_id = user_["timestamp"] + "_" + user_["id"].substring(user_["id"].length - 8)
        //console.log(this.session_id)

        this.firestore.updateDocs("systems", this.moduleId, {users: {[this.session_id]: {[pageToFind]: enable}}})
    }

    updateSystemName(){
        this.rtdbService.singlePathUpdate("/systems_names", this.moduleId, {name: this.moduleName})
    }

    updateFMAlias(sensor, alias){
        this.rtdbService.singlePathUpdate(`/fm_alias/${this.moduleId}/`, sensor, alias)
    }
}